import React, { useState, useEffect, Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { FaTimes } from 'react-icons/fa';
import axios from '../../../services/api';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const AssignEntranceModal = ({ isOpen, onClose, building, onSuccess }) => {
  const { t } = useTranslation();
  const [unassignedSips, setUnassignedSips] = useState([]);
  const [selectedSip, setSelectedSip] = useState(building?.sipAccount || '');

  const [unassignedLocks, setUnassignedLocks] = useState([]);
  const [selectedLock, setSelectedLock] = useState(building?.lockId || '');

  useEffect(() => {
    setSelectedSip(building?.sipAccount || '');
    setSelectedLock(building?.lockId || '');
    if (isOpen) {
      fetchUnassignedSips();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen,building]);

  const fetchUnassignedSips = async () => {
    try {
      const response = await axios.get(`/settings/unassigned-sips?sipAccount=${building.sipAccount}&type=webrtc`);
      setUnassignedSips(response.data);
      const responseLock = await axios.get(`/settings/unassigned-locks?lockId=${building.lockId}`);
      setUnassignedLocks(responseLock.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAssign = async () => {
    if (!selectedSip) {
      toast.error(t('Please select a webrtc account'));
      return;
    }
    if (!selectedLock) {
      toast.error(t('Please select a lock'));
      return;
    }

    try {
      await axios.post('/settings/assign-building-sip', {
        buildingId: building._id,
        sipAccount: selectedSip,
        lockId: selectedLock
      });
      setSelectedSip('');
      setSelectedLock('');
      toast.success(t('SIP account assigned successfully'));
      onSuccess();
      onClose();
    } catch (error) {
      console.log(error);
      // toast.error('Failed to assign SIP account');
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60]">
        <div className="bg-white w-[30vw] rounded-lg shadow-xl overflow-hidden">
          <div className="bg-black text-white flex justify-between items-center px-4 py-3 border-b">
            <h2 className="text-lg">{t('Setting')}</h2>
            <button onClick={onClose}>
              <FaTimes />
            </button>
          </div>

          <div className="p-4">
            <div className="mb-4">
              <div className="text-sm mb-2">{t('Select one from unassigned Webrtc List')}</div>
              <select
                value={selectedSip}
                onChange={(e) => setSelectedSip(e.target.value)}
                className="w-full border rounded px-3 py-2"
              >
                <option value="">{t('Select Webrtc Account')}</option>
                {unassignedSips.map(sip => (
                  <option key={sip._id} value={sip.username}>
                    {sip.username}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <div className="text-sm mb-2">{t('Select one from unassigned Lock List')}</div>
              <select
                value={selectedLock}
                onChange={(e) => setSelectedLock(e.target.value)}
                className="w-full border rounded px-3 py-2"
              >
                <option value="">{t('Select Lock')}</option>
                {unassignedLocks.map(lock => (
                  <option key={lock._id} value={lock.uuid}>
                    {lock.uuid}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-end gap-2 px-4 py-3 border-t">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
            >
              {t('Cancel')}
            </button>
            <button
              onClick={handleAssign}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              {t('Save')}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  );
};

  export default AssignEntranceModal;
